export class Tags {
  async all() {
    const response = await fetch("/api/v3/tags", { credentials: "include" })
    return await response.json()
  }

  async create(attributes) {
    const response = await fetch("/api/v3/tags", {
      credentials: "include",
      method: "POST",
      body: JSON.stringify({ tag: attributes }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    })
    return await response.json()
  }
}
